import { createContext } from 'react';
import { TranslationContextType } from '../types/translation.types';

export const DEFAULT_LANGUAGE = 'en';

const TranslationContext = createContext<TranslationContextType | null>(null);

export { TranslationContext };
